export default "__VITE_PUBLIC_ASSET__ac448520__"